import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import CardSection from 'components/sales/cardSection/cardSection';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import {toast} from "react-toastify";
import DivLayout from 'components/sales/divLayout/divLayout';
import ModalPop from "components/sales/modal/modal";
import FileUpload from "components/sales/fileUpload/fileUpload";
import Images from 'assets/images/imageData';
import ActivityTimeline from 'components/sales/activityTimeline/ActivityTimeline';
import './prConfirmationDetails.css';

const PrConfirmationDetails = ({
  match,
  history,
  getPrConfirmationDetails,
  prConfirmationDetails,
  approvePRRequest,
  updatePR,
  documentUploadUrlPublic,
  documentUrlDataPublic
}) => {

  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [prNo, setPrNo] = useState(null);
  const [prDetails, setPrDetails] = useState('');
  const [historyData, setHistoryData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [showActionModal, setShowActionModal] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [actionType, setActionType] = useState("");
  const [editableBoq, setEditableBoq] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [uploadedDoc, setUploadedDoc] = useState("");
  const [siteAmountSummary, setSiteAmountSummary] = useState(null);
  
  const totalGstAmount = (editableBoq || []).reduce((acc, item) => acc + (Number(item.gst_amount) || 0), 0);
  const totalProductTotal = (editableBoq || []).reduce((acc, item) => acc + (Number(item.product_total) || 0), 0);
  const totalSubTotal = (editableBoq || []).reduce((acc, item) => acc + (Number(item.unit_rate) * Number(item.quantity) || 0), 0);

  const canEditBoq = prDetails?.can_edit_boq === true;

  const calculateGst = (item, qty) => {
    const billingState = addressData.find(a => a.address?.address_type === 1)?.addressDetails?.state;
    const vendorState = addressData.find(a => a.address?.address_type === 3)?.addressDetails?.state;

        const gstRate = item.gst !== undefined 
        ? Number(item.gst) 
        : (item.gst_percent !== undefined 
          ? Number(item.gst_percent) 
          : Number(item.gst_rate || 0));
    
    let igst_percent = 0;
    let cgst_percent = 0;
    let sgst_percent = 0;

    if (billingState && vendorState && billingState.toLowerCase() !== vendorState.toLowerCase()) {
      igst_percent = gstRate;
    } else {
      cgst_percent = gstRate / 2;
      sgst_percent = gstRate / 2;
    }

    const unitRate = item.unit_rate !== undefined ? Number(item.unit_rate) : (item.rate !== undefined ? Number(item.rate) : Number(item.rates || 0));
    const amount = Number(unitRate) * Number(qty);
    const igst_rate = (amount * igst_percent) / 100;
    const cgst_rate = (amount * cgst_percent) / 100;
    const sgst_rate = (amount * sgst_percent) / 100;
    const gst_amount = igst_rate + cgst_rate + sgst_rate;
    const product_total = amount + gst_amount;

    return {
      igst_percent,
      cgst_percent,
      sgst_percent,
      igst_rate: Number(igst_rate.toFixed(2)),
      cgst_rate: Number(cgst_rate.toFixed(2)),
      sgst_rate: Number(sgst_rate.toFixed(2)),
      gst_amount: Number(gst_amount.toFixed(2)),
      product_subtotal: Number(amount.toFixed(2)),
      product_total: Number(product_total.toFixed(2))
    };
  };

  useEffect(() => {
    if (materialData?.length > 0 && addressData?.length > 0) {
      const formatted = materialData.map(item => {
        const calculations = calculateGst(item, item.quantity);
        
        const matchedBoq = serviceList?.find(s => 
          Number(s.service_id) === Number(item.material_service_id) && 
          Number(s.rates) === Number(item.unit_rate)
        );

        return {
          id: item.id,
          boq_id: item.boq_id || matchedBoq?.id || null,
          material_service_id: item.material_service_id,
          name: item.name,
          description: item.description,
          type: item.type,
          code: item.material_service_code,
          quantity: item.quantity,
          rate: item.unit_rate,
          gst_rate: item.gst !== undefined ? item.gst : (item.gst_percent || 0),
          hsn: item.hsn,
          uom: item.uom,
          unit_rate: item.unit_rate,
          document: item.document,
          uploaded_doc: item.uploaded_doc,
          ...calculations
        };
      });
      setEditableBoq(formatted);
    }
  }, [materialData, addressData, serviceList]);

  const handleQtyChange = (index, value) => {
    const updated = [...editableBoq];
    const qty = Number(value);
    updated[index].quantity = qty;
    const calculations = calculateGst(updated[index], qty);
    
    updated[index] = {
      ...updated[index],
      ...calculations
    };
    
    setEditableBoq(updated);
  };

  const handleDelete = (index) => {
    const updated = editableBoq.filter((_, i) => i !== index);
    setEditableBoq(updated);
  };

  const handleAddBoq = (item) => {
    setEditableBoq(prev => [
      ...prev,
      {
        id: item.id,
        name: item.service_name,
        code: item.service_code,
        type: item.type,
        quantity: 1,
        rate: item.rates,
        gst_rate: item.gst !== undefined ? item.gst : (item.gst_percent || 0),
        hsn: item.hsn_code,
        uom: item.uom,
        uom_name: item.uom_name,
        unit_rate: item.unit_rate,
        igst_percent: item.igst_percent,
        igst_rate: item.igst_rate,
        cgst_percent: item.cgst_percent,
        cgst_rate: item.cgst_rate,
        sgst_percent: item.sgst_percent,
        sgst_rate: item.sgst_rate,
        gst_amount: item.gst_amount,
        product_total: item.product_total,
        document: item.document,
        uploaded_doc: item.uploaded_doc,
      }
    ]);
  };

  const updatePRItems = async () => {
    try {
      setIsLoading(true);

      const hasInvalidQty = editableBoq.some(
        item => !item.quantity || item.quantity <= 0
      );

      if (hasInvalidQty) {
        toast.error("Quantity cannot be 0 for any item.");
        return;
      }

      const calculatedSubTotal = editableBoq.reduce(
        (sum, item) => sum + (Number(item.unit_rate) * Number(item.quantity)),
        0
      );

      const calculatedTax = editableBoq.reduce(
        (sum, item) => sum + Number(item.gst_amount),
        0
      );

      const calculatedTotal = calculatedSubTotal + calculatedTax;

      const payload = {
        id: Number(prNo),
        pr_total: Number(calculatedTotal.toFixed(2)),
        pr_sub_total: Number(calculatedSubTotal.toFixed(2)),
        pr_tax: Number(calculatedTax.toFixed(2)),
        items: editableBoq.map(item => ({
          pr_id: Number(prNo),
          id: item.id,
          boq_id: item.boq_id,
          type: item.type,
          material_service_id: item.material_service_id,
          material_service_code: item.code,
          name: item.name,
          description: item.description,
          quantity: item.quantity,
          uom: item.uom,
          hsn: item.hsn,
          igst_rate: item.igst_rate,
          igst_percent: item.igst_percent,
          cgst_rate: item.cgst_rate,
          cgst_percent: item.cgst_percent,
          sgst_rate: item.sgst_rate,
          sgst_percent: item.sgst_percent,
          unit_rate: item.unit_rate,
          product_subtotal: item.product_subtotal,
          product_total: item.product_total,
          gst_percent: item.gst_rate,
          gst_amount: item.gst_amount,
          document: item.document,
        }))
      };

      const res = await updatePR(payload);

      if (res?.data?.status === 0 || res?.data?.status === 200) {
        toast.success("PR updated successfully!");
        if (getPrConfirmationDetails) {
          getPrConfirmationDetails(prNo);
        }
      } else {
        toast.error(res?.message || "Failed to update PR");
      }

    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddBoqFromDropdown = (id) => {
    if (!id) return;

    const item = serviceList.find(s => s.id == id);
    if (!item) return;

    const existingIndex = editableBoq.findIndex(b => 
      b.material_service_id == item.service_id && 
      Number(b.unit_rate) === Number(item.rates)
    );
    
    if (existingIndex !== -1) {
      const updated = [...editableBoq];
      const newQty = (updated[existingIndex].quantity || 0) + 1;
      const calculations = calculateGst(item, newQty);
      
      updated[existingIndex] = {
        ...updated[existingIndex],
        quantity: newQty,
        ...calculations
      };
      setEditableBoq(updated);
      toast.info(`Increased quantity for ${item.service_name}`);
    } else {
      const calculations = calculateGst(item, 1);
      setEditableBoq(prev => [
        ...prev,
        {
          boq_id: item.id,
          material_service_id: item.service_id,
          name: item.service_name,
          description: item.description,
          code: item.service_code,
          type: 2,
          quantity: 1,
          rate: item.rates,
          gst_rate: item.gst !== undefined ? item.gst : (item.gst_percent || 0),
          hsn: item.hsn_code,
          uom: item.uom,
          uom_name: item.uom_name,
          unit_rate: Number(item.rates),
          document: item.document,
          uploaded_doc: item.uploaded_doc,
          ...calculations
        }
      ]);
      toast.success(`Added ${item.service_name}`);
    }
  };

  useEffect(() => {
    if (getPrConfirmationDetails !== null && match.params.pr_id !== null)
      (async () => {
        setPrNo(match.params.pr_id);
        setIsLoading(true);
        await getPrConfirmationDetails(match.params.pr_id);
        setIsLoading(false);
      })();
  }, [getPrConfirmationDetails,match.params.pr_id]);

  useEffect(() => {
    if(prConfirmationDetails !== null && prConfirmationDetails != undefined) {
        setPrDetails(prConfirmationDetails?.pr_details);   
        setHistoryData(prConfirmationDetails?.history_data); 
        setMaterialData(prConfirmationDetails?.material_service);
        setAddressData(prConfirmationDetails?.address); 
        setServiceList(prConfirmationDetails?.boq_data || []);
        setSiteAmountSummary(prConfirmationDetails?.site_amount_summary || null);
    }
  },[prConfirmationDetails]);

  const approvePR = async (status) => {
    try {
      setIsLoading(true);

      const payload = {
        id: prNo,
        remarks: remarks,
        action: status === "APPROVED" ? "APPROVE" : "REJECT",
        document: uploadedDoc
      };

      const res = await approvePRRequest(payload);

      if (res?.data?.status === 0) {
        const role_id = localStorage.getItem("fusion-role");
        const successMessage = payload.action === "APPROVE"
          ? "PR approved successfully!"
          : (["8", "10"].includes(role_id) ? "PR rejected successfully!" : "PR sent back for modification successfully!");

        toast.success(successMessage);

        setShowActionModal(false);
        setRemarks("");
        setUploadedDoc("");
        window.history.back();
      } else {
        toast.error(res?.message || "Failed to process PR");
      }
    } catch (error) {
      console.error("Error while processing PR:", error);
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const headerBtns = () => {

    const role_id = localStorage.getItem("fusion-role");
    const rejectButton = ['8', '10'].includes(role_id) ? 'Reject' : 'Send Back For Modification';

    return (
      <Fragment>
        <>
          <Button
            onClick={() => {
              setActionType("APPROVED");
              setShowActionModal(true);
            }}
            className="filter-hamburger btn btn-transparent"
          >
            Approve
          </Button>

          <Button
            onClick={() => {
              setActionType("REJECTED");
              setShowActionModal(true);
            }}
            className="filter-hamburger btn btn-transparent"
          >
            {rejectButton}
          </Button>
        </>
      </Fragment>
    );

  };

  return (
    <Layout
      title={localization.prdetails}
      isLoading={isLoading}
      isGoback
      Buttons={prDetails?.show_approval ? headerBtns : null}
      linkUrl={`${baseUrl}/service-pr-list`}
    >

    <CardSection title={localization.prdetails}> 
      {prDetails?.next_approval && (
        <div className="next-approval-banner">
          <div className="next-approval-label">NEXT APPROVAL</div>
          <div className="next-approval-value">{prDetails.next_approval}</div>
        </div>
      )}
      <div className="details-listing dl-view">
     <DivLayout
       heading={`PR Id`}
       data={prDetails?.id}
     /> 
     <DivLayout
       heading={`PR Type`}
       data={prDetails?.pr_sub_type_name ?? 'NA'}
     /> 
     <DivLayout
       heading={`Requested By`}
       data={prDetails?.requested_by}
     /> 
     <DivLayout
       heading={`Site No`}
       data={prDetails?.site_no}
     /> 
     <DivLayout
       heading={`Delivery Date`}
       data={prDetails?.delivery_date}
     /> 
     <DivLayout
       heading={`Status`}
       data={prDetails?.status_name ?? 'NA'}
     /> 
     <DivLayout
       heading={`PR Sub Total`}
       data={prDetails?.pr_sub_total}
     /> 
     <DivLayout
       heading={`PR Tax`}
       data={prDetails?.pr_tax}
     />
     <DivLayout
       heading={`PR Total`}
       data={prDetails?.pr_total}
     />  
     <DivLayout
       heading={`Installation Amount`}
       data={prDetails?.installation_amount}
     />
     {Number(prDetails?.pr_type) === 3 && Number(prDetails?.pr_sub_type) === 4 ? (
       <>
         <DivLayout
           heading={`Installation PR Sub Total`}
           data={siteAmountSummary?.installation_pr_sub_total ?? 'N/A'}
         />
         <DivLayout
           heading={`Additional Installation PR Sub Total (IH Approved)`}
           data={siteAmountSummary?.additional_prs_sub_total ?? 'N/A'}
         />
         <DivLayout
           heading={`Cumulative Service PR Sub Total`}
           data={siteAmountSummary?.cumulative_service_pr_sub_total ?? 'N/A'}
         />
         {siteAmountSummary?.installation_pr?.id ? (
           <DivLayout
             heading={`Installation PR Id`}
             data={siteAmountSummary.installation_pr.id}
           />
         ) : null}
         {Array.isArray(siteAmountSummary?.additional_prs) && siteAmountSummary.additional_prs.length > 0 ? (
           <DivLayout
             heading={`IH Approved Additional PR Ids`}
             data={siteAmountSummary.additional_prs.map((pr) => `${pr.id} (${pr.pr_sub_total})`).join(', ')}
           />
         ) : null}
       </>
     ) : null}
     <DivLayout
       heading={`Category`}
       data={prDetails?.pr_category_name}
     /> 
     <DivLayout
       heading={`LOB`}
       data={prDetails?.lob}
     /> 
     <DivLayout
       heading={`SUB LOB`}
       data={prDetails?.sub_lob}
     /> 
     <DivLayout
       heading={`Created By`}
       data={prDetails?.created_by}
     />
     <DivLayout
       heading={`Scope`}
       data={prDetails?.scope}
     /> 
     <DivLayout
       heading={`Comment`}
       data={prDetails?.comment}
     /> 
     </div>
    </CardSection>
    {addressData?.length > 0 && addressData.map((item,key) => 
        <CardSection 
         title={item.address?.address_type == 1 ? localization.addOne 
         : item.address?.address_type == 2 ? localization.addTwo
         : item.address?.address_type == 3 ? localization.addThree
         : item.address?.address_type == 4 ? localization.addFour 
         : 'NA' }
        > 
            <div className="details-listing dl-view"> 
               {item.address?.address_type == 3 ? (
                <DivLayout
                    heading={`Firm Name`}
                    data={item?.addressDetails?.company_name}
                /> 
               ):null}   
               {item?.addressDetails?.delivery_addr_type != null && item?.addressDetails?.delivery_addr_type != undefined ? (
                <DivLayout
                    heading={`Address Type`}
                    data={item?.addressDetails?.delivery_addr_type == 1 ? 'Client Site'
                    : item?.addressDetails?.delivery_addr_type == 2 ? 'Warehouse' 
                    : 'N/A'}
                /> 
                ):null}
                {item.address?.address_type != 3 ? (
                <DivLayout
                    heading={`Client Name`}
                    data={item?.addressDetails?.company_name}
                /> 
                ):null}
                <DivLayout
                    heading={`Name`}
                    data={item?.addressDetails?.name}
                /> 
                <DivLayout
                    heading={`GSTIN No.`}
                    data={item?.addressDetails?.gst_no}
                /> 
                <DivLayout
                    heading={`State`}
                    data={item?.addressDetails?.state}
                /> 
                <DivLayout
                    heading={`City`}
                    data={item?.addressDetails?.city}
                /> 
                <DivLayout
                    heading={`Pincode`}
                    data={item?.addressDetails?.pincode}
                /> 
                <DivLayout
                    heading={`Contact No.`}
                    data={item?.addressDetails?.contact_no}
                /> <DivLayout
                    heading={`Email`}
                    data={item?.addressDetails?.email}
                /> 
                <DivLayout
                    heading={`Address`}
                    data={item?.addressDetails?.address}
                /> 
            </div> 
        </CardSection>
    )}
    <CardSection
      clsName="material-service-header"
      title={
        <>
          <span className="header-title-text">
            {localization.materialAndService}
          </span>

          {canEditBoq && (
            <div className="header-controls-container">
              <select
                className="form-control premium-dropdown"
                onChange={(e) => handleAddBoqFromDropdown(e.target.value)}
              >
                <option value="">+ Add Material / Service</option>
                {serviceList?.map((item, idx) => (
                  <option key={idx} value={item.id}>
                    {item.service_name} (Rate: {item.rates})
                  </option>
                ))}
              </select>

              <Button
                className="premium-update-btn"
                onClick={updatePRItems}
              >
                Update PR
              </Button>
            </div>
          )}
        </>
      }
    >

      {editableBoq?.length > 0 && (
        <div className="table-responsive pr-table-container">
          <table className="table table-bordered pr-table">
            <thead>
              <tr>
                <th>S.No</th> 
                <th>Type</th> 
                <th>Code</th> 
                <th>Name</th> 
                <th>UOM</th> 
                <th>HSN</th>
                <th>Document</th> 
                <th>Unit Price</th> 
                <th>IGST(%)</th> 
                <th>IGST rate</th> 
                <th>CGST(%)</th> 
                <th>CGST Rate</th> 
                <th>SGST(%)</th> 
                <th>SGST Rate</th> 
                <th>GST Amount</th>
                <th>Sub Total</th>
                <th>Total</th>
                <th>Quantity</th> 
                {canEditBoq && <th>Action</th>}
              </tr>
            </thead>

            <tbody>
              {editableBoq.map((item, index) => (
                <tr key={index}>
                  <td>{index+1}</td>
                  <td>{item.type == 1 ? 'Material'
                  : item.type == 2 ? 'Service' 
                  : item.type == 3 ? 'Non Material'
                  : 'NA'}</td>
                  <td>{item.code}</td>
                  <td>{item.name}</td>
                  <td>{item.uom_name || item.uom}</td>
                  <td>{item.hsn}</td>
                  <td>
                    {item.uploaded_doc ? (
                      <a 
                        href={item.uploaded_doc} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="view-doc-link"
                      >
                        View
                      </a>
                    ) : (
                      'NA'
                    )}
                  </td>
                  <td>{item.unit_rate}</td>
                  <td>{item.igst_percent}</td>
                  <td>{item.igst_rate}</td>
                  <td>{item.cgst_percent}</td>
                  <td>{item.cgst_rate}</td>
                  <td>{item.sgst_percent}</td>
                  <td>{item.sgst_rate}</td>
                  <td>{item.gst_amount}</td>
                  <td>{Number(item.unit_rate) * Number(item.quantity)}</td>
                  <td>{item.product_total}</td>

                  <td style={{ width: "120px" }}>
                    {canEditBoq ? (
                      <input
                        type="number"
                        min="1"
                        className="form-control"
                        value={item.quantity || ""}
                        onChange={(e) =>
                          handleQtyChange(index, parseInt(e.target.value, 10) || 0)
                        }
                      />
                    ) : (
                      item.quantity
                    )}
                  </td>

                  {canEditBoq && (
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDelete(index)}
                      >
                        Delete
                      </Button>
                    </td>
                  )}

                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-flex justify-content-end mt-3 pr-4" style={{ gap: '40px', fontWeight: 'bold' }}>
            <div>
              <span className="text-muted mr-2">Total GST:</span>
              <span>{totalGstAmount.toFixed(2)}</span>
            </div>
            <div>
              <span className="text-muted mr-2">Total Sub Total:</span>
              <span>{totalSubTotal.toFixed(2)}</span>
            </div>
            <div>
              <span className="text-muted mr-2">Grand Total:</span>
              <span className="text-primary">{totalProductTotal.toFixed(2)}</span>
            </div>
          </div>
        </div>
      )}
    </CardSection>

    <CardSection title="Activity Timeline">
      <ActivityTimeline data={historyData} />
    </CardSection>

      <ModalPop
        title={localization.conf}
        show={showActionModal}
        handleModalHide={() => {
          setShowActionModal(false);
          setRemarks("");
          setActionType("");
          setUploadedDoc("");
        }}
      >
        <div className="text-center">
          <h4>
            Are you sure you want to {actionType === "APPROVED" ? "approve" : "reject"} this PR?
          </h4>

          <div className="row justify-content-center mt-4">
            <div className="col-md-5 mx-auto">
              <TextAreaInput
                label="Remarks"
                inputValue={remarks}
                required
                isStarRequired
                rows={3}
                handleChange={(e) => {
                  setRemarks(e.target.value);
                }}
              />
            </div>

            <div className="col-md-5 mx-auto">
              <FileUpload
                id="approvalDocument"
                accept=".pdf,.png,.jpg,.jpeg,.doc"
                documentUploadUrl={documentUploadUrlPublic}
                documentUrlData={documentUrlDataPublic}
                onChange={(val) => setUploadedDoc(val)}
                width="100%"
              >
                <span className="btn btn-transparent border w-100 mt-4">
                  {localization.document}
                </span>
              </FileUpload>
            </div>
          </div>

          <div className="d-flex justify-content-center mt-5">
            <Button
              className="btn btn-danger mr-3"
              onClick={() => {
                setShowActionModal(false);
                setRemarks("");
                setActionType("");
                setUploadedDoc("");
              }}
            >
              No
            </Button>

            <Button
              className="btn btn-success ml-3"
              disabled={!remarks}
              onClick={() => approvePR(actionType)}
            >
              Yes
            </Button>
          </div>
        </div>
      </ModalPop>

    </Layout>
  );
};
export default PrConfirmationDetails;
